import React from 'react';
import ProjectSearch from './ProjectSearch'; // Adjust path if different

const Abstract = () => {
  return (
    <div className="">
      <ProjectSearch />
    </div>
  );
};

export default Abstract;
